import { Component, OnInit } from '@angular/core';
import { SignupService } from 'src/app/services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';
@Component({
    selector: 'app-uk-to-au-component',
    templateUrl: './uk-to-au-component.html',
    styleUrls: ['./uk-to-au-component.css']
})
export class UkToAuComponent implements OnInit {

    constructor(
        public signUpService: SignupService,
        private watcherService: WatcherService
    ) { }

    lang;
    ngOnInit(): void {
        this.watcherService.getLang().subscribe(
            lang => {
                this.lang = lang;
            }
        )
        
        this.signUpService.updateWebsiteTitle("Shop from UK to Australia with Shippn - Fast and Easy Shipping");
        this.signUpService.updateWebsiteDescription("This page explains how to shop online from UK and ship through Shippn hosts that live in UK , get it delivered to your address in Australia.")
    }
}
